import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import CmsPlaceholder from 'components/cms-placeholder';
import OnboardingIntro from './intro';

class Onboarding extends PureComponent {
    static propTypes = {
        onLoaded: PropTypes.func.isRequired,
        pageName: PropTypes.string.isRequired,
    };

    render() {
        const { pageName } = this.props;
        return [
            <OnboardingIntro key="intro"/>,
            <CmsPlaceholder key="placeholder" onLoaded={this.props.onLoaded} id={pageName}/>,
        ];
    };
};

export default connect(
    reduxUtils.mapStateToProps({
        pageName: 'router.name',
    }),
)(Onboarding);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/onboarding/index.js